import { INIT_STATE, States, Actions } from './type'
import _ from 'lodash';

export const Reducer = (state: States = INIT_STATE, action: Actions) => {
    // init
    let newState = _.cloneDeep([state])[0];
    // switch actions
    switch (action.type) {
        case 'RESET_STATE': {
            if (typeof action.path !== 'string') {
                newState = INIT_STATE;
            } else {
                _.set(newState, action.path!, _.get(INIT_STATE, action.path!));
            }
            break;
        }
        case 'SET_STATE': {
            _.set(newState, action.path, _.get(action, 'value'));
            break;
        }
        default: { break; }
    }
    // return
    return newState;
}